export default __webpack_public_path__ + "static/media/Stryker_Frente.cc50d997.webp";